(() => {
  if (customElements.get('vibtrend-set-info')) return;

  class VibtrendSetInfo extends HTMLElement {
    connectedCallback() {
      if (this._onChange) return;
      const data = this.querySelector('script[data-set-info-data]');
      this._items = this.querySelector('[data-set-items]');
      if (!data || !this._items) return;

      try {
        this._data = JSON.parse(data.textContent);
      } catch (_) {
        this.hidden = true;
        return;
      }

      this._scope = this.closest('.shopify-section') || this.parentElement;
      this._onChange = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        if (target.matches('input[name="id"], select[name="id"]')) {
          const productOwner = target.closest('[data-product-id]');
          if (productOwner && productOwner.dataset.productId !== this.dataset.productId) return;
          this._showVariant(target.value);
          return;
        }

        const picker = target.closest('[data-variant-picker]');
        if (picker && picker.dataset.productId === this.dataset.productId) {
          this._showPicker(picker);
        }
      };

      this._scope.addEventListener('change', this._onChange);
      this._showVariant(this._data.initialVariantId);
      this._scope.querySelectorAll('[data-variant-picker]').forEach((picker) => {
        if (picker.dataset.productId === this.dataset.productId) this._showPicker(picker);
      });
    }

    disconnectedCallback() {
      if (this._scope && this._onChange) this._scope.removeEventListener('change', this._onChange);
      this._scope = null;
      this._onChange = null;
    }

    _showPicker(picker) {
      const position = String(this._data.optionPosition);
      const selected = picker.querySelector(
        `[data-option-position="${position}"] input:checked, option[data-option-position="${position}"]:checked`
      );
      if (!selected) return;
      const value = this._data.optionValues.find((entry) => entry.value === selected.value);
      if (value) this._show(value.key);
    }

    _showVariant(id) {
      const key = this._data.variantSets[String(id)];
      if (key) this._show(key);
    }

    _show(key) {
      const text = this._data.contents[key];
      if (typeof text !== 'string' || !text) return;
      this.hidden = false;
      this._items.textContent = text;
      this.dataset.currentSet = key;
    }
  }

  customElements.define('vibtrend-set-info', VibtrendSetInfo);
})();
